import React, { useRef, useEffect } from "react";
import "./VideoBackground.css"; // Importando o CSS
import WelcomeVideo from "../../assets/mov/welcome.mp4"
import { useMediaQuery } from 'react-responsive';




const VideoBackground = () => {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const videoRef = useRef(null); // Criando uma referência para o vídeo

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.85; // Define a velocidade (0.5 é mais lento, 1 é normal)
    }
  }, []);

  return (
    <div className="video-container">
      {/* Vídeo de fundo */}
      <video ref={videoRef} autoPlay loop muted playsInline className="background-video">
        <source src={WelcomeVideo} type="video/mp4" />
        Seu navegador não suporta vídeos HTML5.
      </video>


      <div className="overlay"></div>


      {!isMobile && (
        <div className="text-content">
          <h1> Bem-vindo a Ouro Preto! </h1>
          <h3>Os melhores anos da sua vida começam aqui.</h3>
        </div>
      )}
      {isMobile && (
        <div className="text-content">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2> Bem-vindo a Ouro Preto! </h2>
          <h4>Os melhores anos da sua vida começam aqui.</h4>
        </div>
      )}
    </div>
  );
};

export default VideoBackground;